<template>
    <div :class="signUped ? 'mobile' : 'content'" type="false">
        <headers_m></headers_m>
        <div class="main">
            <div class="waiting">
                <img src="https://oss.eventnet.cn/H5/mi/waiting_icon.png" />
                <p class="waiting_text" style="text-transform: uppercase">
                    {{ $t("waiting").title }}
                </p>
            </div>
        </div>
        <!-- <div class="main">
            <div
                v-if="signUped"
                style="
                    flex: 1;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                "
            >
                <div class="register_view_mobile" v-if="step1">
                    <div class="step">
                        <p>
                            <img
                                src="https://oss.eventnet.cn/H5/mi/step_select-1.png"
                                alt=""
                            />
                            <span>{{ $t("signUp").password.title1 }}</span>
                        </p>
                        <p>
                            <img
                                src="https://oss.eventnet.cn/H5/mi/line.png"
                                alt=""
                            />
                            <span>{{ $t("signUp").password.title }}</span>
                        </p>
                        <p>
                            <img
                                src="https://oss.eventnet.cn/H5/mi/step_select.png"
                                alt=""
                            />
                            <span>{{ $t("signUp").password.title }}</span>
                        </p>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p>
                            <span>{{ $t("signUp").name.title }}</span
                            >：
                            <input
                                class="input_half"
                                type="text"
                                name="name"
                                v-model="name"
                                :placeholder="$t('signUp').name.placeholder"
                            />
                        </p>
                        <p>
                            <span>{{ $t("signUp").email.title }}</span
                            >：
                            <input
                                class="input_half"
                                type="text"
                                name="email"
                                v-model="email"
                                :placeholder="$t('signUp').email.placeholder"
                            />
                        </p>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p>
                            <span>{{ $t("signUp").country.title }}</span
                            >：
                            <input
                                class="input_half"
                                type="text"
                                name="country"
                                v-model="country"
                                :placeholder="$t('signUp').country.placeholder"
                            />
                        </p>
                        <p>
                            <span>{{ $t("signUp").region.title }}</span
                            >：
                            <input
                                class="input_half"
                                type="text"
                                name="region"
                                v-model="region"
                                :placeholder="$t('signUp').region.placeholder"
                            />
                        </p>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p>
                            <span>{{ $t("signUp").company.title }}</span
                            >：
                            <input
                                class="input_half"
                                type="text"
                                name="company"
                                v-model="company"
                                :placeholder="$t('signUp').company.placeholder"
                            />
                        </p>
                        <p>
                            <span>{{ $t("signUp").job_title.title }}</span
                            >：
                            <input
                                class="input_half"
                                type="text"
                                name="job_title"
                                v-model="job_title"
                                :placeholder="
                                    $t('signUp').job_title.placeholder
                                "
                            />
                        </p>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p>
                            <span>{{ $t("signUp").meeting_type.title }}</span
                            >：
                            <select
                                style="flex: 1"
                                name="meeting_type"
                                v-model="meeting_type"
                                class="input_half"
                            >
                                <option value="请选择">
                                    {{ $t("signUp").meeting_type.placeholder }}
                                </option>
                                <option
                                    v-for="option in $t('signUp').meeting_type
                                        .select"
                                    :value="option.option"
                                    :key="'va' + option.option"
                                >
                                    {{ option.value }}
                                </option>
                            </select>
                        </p>
                    </div>
                    <div
                        v-if="meeting_type == 1"
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p>
                            <span>{{ $t("signUp").is_dine.title }}</span
                            >：
                            <select
                                name="is_dine"
                                class="input_half"
                                v-model="is_dine"
                            >
                                <option value="请选择">
                                    {{ $t("signUp").is_dine.placeholder }}
                                </option>
                                <option
                                    v-for="option in $t('signUp').is_dine
                                        .select"
                                    :value="option.option"
                                    :key="'vd' + option.option"
                                >
                                    {{ option.value }}
                                </option>
                            </select>
                        </p>
                        <p>
                            <span>{{ $t("signUp").cellphone.title }}</span
                            >：
                            <input
                                class="input_half"
                                type="text"
                                minlength="8"
                                name="cellphone"
                                v-model="cellphone"
                                :placeholder="
                                    $t('signUp').cellphone.placeholder
                                "
                            />
                        </p>
                    </div>
                    <p class="login_btn_m" @click="next">
                        {{ $t("signUp").btn }}
                    </p>
                </div>
                <p v-if="step1" class="toRegister">{{ $t("signUp").tips }}</p>
                <div class="login_mobile" v-if="step2">
                    <div class="step">
                        <p>
                            <img
                                src="https://oss.eventnet.cn/H5/mi/step_select-1.png"
                                alt=""
                            />
                            <span>{{ $t("signUp").password.title1 }}</span>
                        </p>
                        <p>
                            <img
                                src="https://oss.eventnet.cn/H5/mi/line.png"
                                alt=""
                            />
                            <span>{{ $t("signUp").password.title }}</span>
                        </p>
                        <p>
                            <img
                                src="https://oss.eventnet.cn/H5/mi/step_select-1.png"
                                alt=""
                            />
                            <span>{{ $t("signUp").password.title }}</span>
                        </p>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p>
                            <span>{{ $t("signUp").email.title1 }}</span
                            >：
                            <input
                                class="input"
                                readonly
                                type="text"
                                name="email"
                                v-model="email"
                                :placeholder="$t('signUp').email.placeholder"
                            />
                        </p>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p>
                            <span>{{ $t("signUp").password.title }}</span
                            >：
                            <input
                                class="input"
                                type="password"
                                minlength="6"
                                maxlength="12"
                                name="password"
                                v-model="password"
                                :placeholder="$t('signUp').password.placeholder"
                            />
                        </p>
                        <img
                            class="tips_icon"
                            @click="tips1"
                            src="https://oss.eventnet.cn/H5/mi/tips_icon.png"
                            alt=""
                        />
                        <div v-if="tips" class="password_tips">
                            <p>{{ $t("signUp").password.tips1 }}</p>
                            <p>{{ $t("signUp").password.tips2 }}</p>
                            <p>{{ $t("signUp").password.tips3 }}</p>
                        </div>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p style="margin-bottom: 10px">
                            <span>{{ $t("signUp").password1.title }}</span
                            >：
                            <input
                                class="input"
                                type="password"
                                minlength="6"
                                maxlength="12"
                                name="password"
                                v-model="password1"
                                :placeholder="
                                    $t('signUp').password1.placeholder
                                "
                            />
                        </p>
                    </div>
                    <div
                        :class="
                            $i18n.locale == 'zh'
                                ? 'register_flex_mobile'
                                : 'register_flex_mobile_en'
                        "
                    >
                        <p style="color: #000">
                            <span style="opacity: 0">{{
                                $t("signUp").password1.title
                            }}</span
                            >：
                            <span
                                class="toRegister"
                                style="
                                    text-align: left;
                                    flex: 1;
                                    line-height: 0;
                                "
                                >{{ $t("signUp").tips_password }}</span
                            >
                        </p>
                    </div>
                    <div class="btns">
                        <p
                            class="login_btn_m"
                            style="background: none; border: 1px solid #ff6900"
                            @click="last"
                        >
                            {{ $t("register").last }}
                        </p>
                        <p class="login_btn_m" @click="submit">
                            {{ $t("register").confirm }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="success" v-else>
                <img
                    src="https://oss.eventnet.cn/H5/mi/success_icon.png"
                    alt=""
                />
                <p class="success_text">{{ $t("signUp").success }}</p>
                <p v-if="adjust == 1 || adjust == 3">
                    {{ $t("signUp").success_tip1 }}
                </p>
                <p v-if="adjust == 1 || adjust == 3">
                    {{ $t("signUp").success_tip2 }}
                </p>
                <p v-if="adjust == 1 || adjust == 3">
                    {{ $t("signUp").success_tip3 }}
                </p>
                <p v-if="adjust == 1 || adjust == 3">
                    {{ $t("signUp").success_tip4 }}
                </p>
                <p v-if="adjust == 2">{{ $t("signUp").error }}</p>
            </div>
        </div> -->
        <div class="footer_mobile">
            Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>

<script>
import headers_m from "../components/headers_m.vue";
export default {
    components: {
        headers_m,
    },
    name: "signUp",
    inject: ["reload"],
    data() {
        return {
            lang: "",
            name: "",
            country: "",
            region: "",
            company: "",
            region: "",
            job_title: "",
            meeting_type: "请选择",
            is_dine: "请选择",
            cellphone: "",
            signUped: true,
            email: "",
            password: "",
            password1: "",
            toastShow: false,
            click: true,
            toastText: "",
            reg: /^1[3456789]\d{9}$/,
            verify: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
            psw_reg: /^[\w]{8,14}$/i, //6-12位
            psw_reg1: /[a-zA-Z]/, //字母
            psw_reg2: /\d/, //数字
            psw_reg3: /_/, //下划线
            psw_reg4: /\W/, //特殊字符
            psw_reg5: /^(?=.*\d)(?=.*[a-zA-Z]).{8,14}$/,
            step1: true,
            step2: false,
            token: localStorage.getItem("token"),
            adjust: localStorage.getItem("adjust"),
            tips: false,
        };
    },
    created() {
        let that = this;
        let lang = localStorage.getItem("lang");
        that.$i18n.locale = that.lang = lang;

        if (that.token == "" || that.token == null) {
            that.signUped = true;
        } else {
            that.signUped = false;
            that.rq.post("/user/userinfo").then((res) => {
                if (res.code == "1") {
                    that.adjust = res.data.userinfo.adjust;
                }
            });
        }
    },
    mounted() {
        /* this.reload()
            this.$router.replace('/signUp').catch(() => {}) */
    },
    watch: {
        meeting_type() {
            this.cellphone = "";
            this.is_dine = "请选择";
        },
    },
    methods: {
        path(e) {
            let that = this,
                path = e.target.dataset.path;
            that.$router.replace("/" + path).catch(() => {});
        },
        next() {
            let that = this,
                data = new FormData();
            if (that.name == "") {
                that.toast(that.$t("signUp").name.placeholder);
                return;
            } else if (that.email == "") {
                that.toast(that.$t("signUp").email.placeholder);
                return;
            } else if (!that.verify.test(that.email)) {
                that.toast(that.$t("signUp").email.error);
                return;
            } else if (that.country == "") {
                that.toast(that.$t("signUp").country.placeholder);
                return;
            } else if (that.region == "") {
                that.toast(that.$t("signUp").region.placeholder);
                return;
            } else if (that.company == "") {
                that.toast(that.$t("signUp").company.placeholder);
                return;
            } else if (that.job_title == "") {
                that.toast(that.$t("signUp").job_title.placeholder);
                return;
            } else if (that.meeting_type == "请选择") {
                that.toast(that.$t("signUp").meeting_type.placeholder);
                return;
            } else if (that.meeting_type == 1) {
                //线下会议
                if (that.is_dine == "请选择") {
                    that.toast(that.$t("signUp").is_dine.placeholder);
                    return;
                } else if (that.cellphone == "") {
                    that.toast(that.$t("signUp").cellphone.placeholder);
                    return;
                } else if (that.cellphone.length < 8) {
                    that.toast(that.$t("signUp").cellphone.error);
                    return;
                }
            } else if (that.meeting_type == 2) {
                //线上会议
                that.cellphone = "";
                that.is_dine = 2;
            }
            data.append("email", that.email);
            that.rq
                .post("/validate/check_email_available", data)
                .then((res) => {
                    if (res.code == "1") {
                        that.step1 = false;
                        that.step2 = true;
                    } else if (res.code == "0") {
                        that.toast(that.$t("register").repeat);
                        return;
                    }
                });
        },
        last() {
            let that = this;
            that.step1 = true;
            that.step2 = false;
        },
        submit() {
            let that = this,
                data = new FormData();
            if (that.click) {
                that.click = false;
                if (that.password == "") {
                    that.toast(that.$t("signUp").password.placeholder);
                    return;
                } else if (!that.psw_reg5.test(that.password)) {
                    that.toast(that.$t("signUp").password.error1);
                    return;
                } else if (that.password1 == "") {
                    that.toast(that.$t("signUp").password1.placeholder);
                    return;
                } else if (that.password == that.password1) {
                    data.append("name", that.name);
                    data.append("email", that.email);
                    data.append("nation", that.country);
                    data.append("region", that.region);
                    data.append("mechanism", that.company);
                    data.append("job_title", that.job_title);
                    data.append("meeting_type", that.meeting_type);
                    data.append("is_dine", that.is_dine);
                    data.append("cellphone", that.cellphone);
                    data.append("email", that.email);
                    data.append("password", that.password);
                    data.append(
                        "avatar",
                        localStorage.getItem("avatar") == null
                            ? ""
                            : localStorage.getItem("avatar")
                    );
                    data.append("nickname", that.name);
                    that.rq.post("/user/register", data).then((res) => {
                        if (res.code == "1") {
                            // that.toast(that.$t('register').success)
                            localStorage.setItem(
                                "sign",
                                res.data.userinfo.audit_status
                            );
                            that.click = true;
                            localStorage.setItem(
                                "token",
                                res.data.userinfo.token
                            );
                            localStorage.setItem(
                                "adjust",
                                res.data.userinfo.adjust
                            );
                            that.adjust = res.data.userinfo.adjust;
                            localStorage.setItem("user", res.data.userinfo);
                            that.signUped = false;
                            that.$router.replace("/signUp").catch(() => {});
                            /* setTimeout(() => {
                                    }, 1400) */
                        } else if (res.code == "250001") {
                            that.toast(that.$t("register").error);
                            return;
                        } else if (res.code == "250002") {
                            that.toast(that.$t("register").repeat);
                            return;
                        }
                    });
                } else {
                    that.toast(that.$t("signUp").password1.error);
                    return;
                }
            }
        },
        tips1() {
            this.tips = !this.tips;
            setTimeout(() => {
                this.tips = !this.tips;
            }, 3000);
        },
        toast(str) {
            let that = this;
            that.toastText = str;
            that.toastShow = true;
            setTimeout(function () {
                that.toastShow = false;
                that.click = true;
            }, 1500);
        },
    },
};
</script>
<style scoped>
.register_view_mobile {
    width: 670px;
    max-height: 92%;
    overflow-y: scroll;
    border-radius: 21px;
    padding: 30px 40px;
    background: linear-gradient(-52deg, #2d1300 0%, #000000 50%, #2d1300 100%);
}

.input_half,
.select {
    width: 100%;
    height: 65px;
    background: #000000;
    border: 1px solid #ff6900;
    border-radius: 6px;
    font-size: 28px;
    text-indent: 10px;
    color: #fff;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
}

.register_flex_mobile,
.register_flex_mobile_en {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

.register_flex_mobile > p,
.register_flex_mobile_en > p {
    font-size: 28px;
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
}

.register_flex_mobile > p > span {
    align-items: center;
    min-width: 120px;
    text-align: justify;
    display: inline-block;
    text-align-last: justify;
    height: 65px;
    line-height: 22px;
}

.register_flex_mobile > p > span::before,
.register_flex_mobile > p > span::after {
    display: inline-block;
    content: "";
    width: 100%;
    height: 0;
    visibility: hidden;
}

.register_flex_mobile > p > span > i {
    display: block;
    width: 100%;
}

.register_flex_mobile_en > p > span {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-width: 220px;
}

.success {
    width: 80%;
    font-size: 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.success img {
    width: 130px;
    height: 130px;
    margin: 0 auto 35px;
    display: inline-block;
}

.success_text {
    text-align: center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-image: linear-gradient(0deg, #ff6900 0%, #cc2200 100%);
    margin-bottom: 130px;
    font-size: 30px;
    font-weight: bold;
}

.success > p {
    width: 100%;
    color: #ff6900;
    line-height: 35px;
}

.btns {
    display: flex;
    justify-content: center;
    box-sizing: border-box;
}

.btns > .login_btn_m {
    width: 250px;
    margin: 40px 20px;
}

.step {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 50px;
}

.step > p {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;
}

.step > p:nth-child(2) {
    margin: 0 10px;
    width: 150px;
    overflow: hidden;
}

.step > p img {
    margin-bottom: 10px;
}

.step > p:nth-child(2) > span {
    opacity: 0;
}

.toRegister {
    font-size: 20px;
}

.password_tips {
    width: 400px;
    /* height: 100px; */
    font-size: 20px;
    color: #000;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    right: 12px;
    bottom: 90px;
    padding: 15px 15px;
}

.password_tips > * {
    padding: 5px 0;
    line-height: 1;
}

.password_tips > *:before {
    content: "";
    line-height: 1;
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 10px;
    background: #000;
    vertical-align: middle;
    margin-right: 8px;
}

.password_tips:after {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    overflow: hidden;
    font-size: 0;
    line-height: 0;
    border-width: 10px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.9) transparent transparent transparent;
    position: absolute;
    bottom: -18px;
    right: 20px;
}

.tips_icon {
    width: 30px;
    position: absolute;
    right: 25px;
    top: 17px;
}
</style>


// WEBPACK FOOTER //
// src/views/signUp.vue